export default "__VITE_ASSET__c03f4519__"